import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: string[] }) => {
  const localUserObj = JSON.parse(localStorage.getItem("localUser") || "{}");
  const userType = localUserObj?.userType;

  if (!userType) {
    return <Navigate to="/login" replace />;
  }

  return allowedRoles.includes(userType) ? <Outlet /> : <Navigate to="/home" replace />;
};

export default ProtectedRoute;